import { organisationsApi } from "@api/organisations";
import { RootState } from "@store/rootReducer";

export const selectOrganisationTheme = (id: string | null) =>
    (state: RootState) => !id ? null : organisationsApi.endpoints.getOrganisationTheme.select(id)(state).data;